export default __webpack_public_path__ + "static/media/illustration-insider.1c9ba4b3.png";